export class ElectronicPaymentModel {
  currency: string = "MXN";
  description: string = "Dispersión a Cuenta Electrónica";
  deviceSessionId: string;
  listOfWinners: TransfersModel[];
}

export class TransfersModel {
  account: string;
  amountPrize: string;
  drawNumber: number;
  fee: number;
  id: TransferId;
  isPayout: boolean; // siempre ira en true
  referencia: string;
  settlementFinancialId: number;
  ticket: number;
  total2Paid: string;
  transactionType: string;
  username: string;
}

export class TransferId {
  ppapProducto: number;
  wagerReferenceId: string;
  wagerReferenceIdKey: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/payments/electronic-payment.model.ts